<template>
  <div class="searchInput lxn-margin-auto lxn-border-round lxn-pos-rel lxn-overflow-hidden">
    <div :class="$store.getters.language.floatClass" class="searchInput-icon">
      <ButtonIcon :size="20" bgColor="#DEDEDE" icon="magnifier" iconColor="#53636C" :padding="5" :isRound="true" />
    </div>
    <div :class="$store.getters.language.floatClass" class="searchInput-input-wrapper lxn-h100">
      <input v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :class="[$store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]" type="text" class="searchInput-input lxn-h100 lxn-w100 lxn-small-text" :placeholder="$store.getters.language.texts.Device_serachPlaceHolder" />
    </div>
    <div :class="$store.getters.language.floatClass" class="searchInput-x lxn-h100" @click="$emit('clearSearchText')">
      <ButtonIcon v-if="value.length" :size="13" bgColor="#53636C" icon="xRound" iconColor="#BCBBBB" :padding="0" :isRound="true" />
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'

export default {
  name: 'searchInput',
  components: {
    ButtonIcon
  },
  props: {
    value: String
  },
  methods: {
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .searchInput {
    width: calc(100% - 36px);
    height: 25px;
    background-color: #ffffff;
    margin-bottom: 10px;
    z-index: 1;
    border-radius: 30px;
  }
  .searchInput-icon {
    width: 25px;
    padding-right: 2px;
    padding-left: 3px;
    padding-top: 3px;
  }
  .searchInput-input-wrapper {
    width: calc(100% - 50px);
  }
  .searchInput-input {
    background-color: #ffffff;
    line-height: 25px;
    color: #53636C;
  }
  .searchInput-x {
    width: 25px;
    padding-right: 6px;
    padding-left: 6px;
    padding-top: 6px;
  }
</style>
